export enum TimePeriod {
    Daily = 1,
    Weekly,
    Monthly
}